export default {
    // BASE_URL: 'http://localhost:3005/'
    // BASE_URL: 'http://api.wisdom-pool.tsh.local/'
    BASE_URL: process.env.REACT_APP_BASE_URL
}